module.exports = __webpack_public_path__ + "img/1511334461.ad18eb78.jpg";